import { render, staticRenderFns } from "./RevenuesPage.vue?vue&type=template&id=06a599a5&scoped=true&"
import script from "./RevenuesPage.vue?vue&type=script&lang=js&"
export * from "./RevenuesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a599a5",
  null
  
)

export default component.exports